import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    body1: (theme) => ({
        color: theme.colors.steelGray,
        fontSize: {
            md: '18px !important',
            xs: '14px !important'
        },
        fontWeight: 400,
        lineHeight: {
            md: '26px !important',
            xs: '22px !important'
        }
    }),

    body2: {
        fontSize: {
            md: '18px !important',
            xs: '18px !important'
        },
        fontWeight: 400,
        lineHeight: '26px !important'
    },

    button: {
        fontSize: {
            md: '18px !important',
            xs: '16px !important'
        },
        fontWeight: 500,
        lineHeight: '24px !important'
    },

    caption: {
        fontSize: {
            md: '16px !important',
            xs: '11px !important'
        },
        fontWeight: 500,
        lineHeight: {
            md: '24px !important',
            xs: '16px !important'
        }
    },

    default: (theme) => ({
        color: theme.colors.plantation,
        fontWeight: 400,
        letterSpacing: 0,
        marginX: '0 !important'
    }),

    fontFamily: (theme) => ({
        fontFamily: `${theme.typography.fontFamily} !important`
    }),

    h1: {
        fontSize: {
            md: '44px !important',
            xs: '24px !important'
        },
        fontWeight: 500,
        lineHeight: {
            md: '56px !important',
            xs: '30px !important'
        }
    },

    h2: {
        fontSize: {
            md: '32px !important',
            xs: '22px !important'
        },
        fontWeight: 500,
        lineHeight: {
            md: '44px !important',
            xs: '28px !important'
        }
    },

    h3: {
        fontSize: {
            md: '28px !important',
            xs: '18px !important'
        },
        fontWeight: 400,
        lineHeight: {
            md: '40px !important',
            xs: '26px !important'
        }
    },

    h4: {
        fontSize: {
            md: '24px !important',
            xs: '14px !important'
        },
        fontWeight: '400 !important',
        lineHeight: {
            md: '36px !important',
            xs: '20px !important'
        }
    },

    h5: {
        fontSize: {
            md: '18px !important',
            xs: '16px !important'
        },
        fontWeight: 600,
        lineHeight: '24px !important'
    },

    h6: {
        fontSize: {
            md: '18px !important',
            xs: '16px !important'
        },
        fontWeight: 400,
        lineHeight: '24px !important'
    },

    subtitle1: {
        fontSize: {
            md: '23px !important',
            xs: '22px !important'
        },
        fontWeight: 600,
        lineHeight: '28px !important'
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
